export default function validStateBadgeClass(status) {
  switch (status) {
    case "conforming":
      return "success";
    case "non_conforming":
      return "danger";
    default:
      return "secondary";
  }
}
